import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { createApiClient } from "./api/client";
import { ApiClientProvider } from "./api/context";
import { loadClientEnv } from "./config/env";
import { ReaderStylePresetProvider } from "./features/reader-style/ReaderStylePresetProvider";
import { DevQueryTools } from "./components/dev/DevQueryTools";
import "./styles/globals.css";

// QueryClient の設定方針:
// - staleTime: Infinity  — シーンデータはサーバーが一意に確定するため、
//   明示的な invalidate が無い限り再取得しない（不要なちらつき防止）。
// - gcTime: 5 分         — 画面離脱後のキャッシュ保持時間。
// - retry: false          — ApiError は ProblemDetail として UI で分岐させるため、
//   RQ 側の暗黙リトライを抑止する。
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: Infinity, gcTime: 5 * 60 * 1000, retry: false },
    mutations: { retry: false },
  },
});

const apiClient = createApiClient(loadClientEnv().apiBaseUrl);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiClientProvider client={apiClient}>
        <ReaderStylePresetProvider>
          <App />
          <DevQueryTools />
        </ReaderStylePresetProvider>
      </ApiClientProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
